import { TimeEntryType } from "./model";
import { dateAdd } from "./utils";
const GermanLocale = {
    states: [
        { name: "Baden-Württemberg", code: "BW" },
        { name: "Bayern", code: "BY" },
        { name: "Augsburg, Bayern", code: "AB" },
        { name: "Berlin", code: "BE" },
        { name: "Brandenburg", code: "BB" },
        { name: "Bremen", code: "HB" },
        { name: "Hamburg", code: "HH" },
        { name: "Hessen", code: "HE" },
        { name: "Mecklenburg-Vorpommern", code: "MV" },
        { name: "Niedersachsen", code: "NI" },
        { name: "Nordrhein-Westfalen", code: "NW" },
        { name: "Rheinland-Pfalz", code: "RP" },
        { name: "Saarland", code: "SL" },
        { name: "Sachsen", code: "SN" },
        { name: "Sachsen-Anhalt", code: "ST" },
        { name: "Schleswig-Holstein", code: "SH" },
        { name: "Thüringen", code: "TH" },
    ],
    // OpenHolidays uses alternative state codes for Germany so we need to map them to the ISO state codes
    openHolidayStateCodes: {
        BW: "BW",
        BY: "BY",
        AB: "BY",
        BE: "BE",
        BB: "BB",
        HB: "HB",
        HH: "HH",
        HE: "HE",
        // MV splits school holidays into Allgemeinbildende Schulen (ABS) and Berufsbildende Schulen (BBS)
        // We only use the ABS holidays for now
        "MV-ABS": "MV",
        NI: "NI",
        NW: "NW",
        RP: "RP",
        SL: "SL",
        SN: "SN",
        ST: "ST",
        SH: "SH",
        TH: "TH",
    },
    maxWorkingHoursPerDay: 10,
    minRestingHours: 11,
    maxProbationPeriodMonths: 6,
    timeEntryTypeLabel(entry) {
        if (!entry.type)
            return "";
        switch (entry.type) {
            case TimeEntryType.Work:
                return "Arbeit";
            case TimeEntryType.Vacation:
                if (entry.days === 0.5) {
                    return "½ Urlaubstag";
                }
                return "Urlaub";
            case TimeEntryType.Sick:
                return "Krank";
            case TimeEntryType.ChildSick:
                return "Kind Krank";
            case TimeEntryType.SickInKUG:
                return "Krank in KUG";
            case TimeEntryType.HourAdjustment:
                return "Zeitbuchung";
            case TimeEntryType.VacationAdjustment:
                return "Urlaubsbuchung";
            case TimeEntryType.Free:
                return "Frei";
            case TimeEntryType.CompDay:
                return "Guttag";
            default:
                return "";
        }
    },
    timeEntryTypeIcon(type) {
        switch (type) {
            case TimeEntryType.Work:
                return "icon.time-entry.work";
            case TimeEntryType.Vacation:
                return "icon.time-entry.vacation";
            case TimeEntryType.Sick:
            case TimeEntryType.SickInKUG:
                return "icon.time-entry.sick";
            case TimeEntryType.ChildSick:
                return "icon.time-entry.child-sick";
            case TimeEntryType.HourAdjustment:
            case TimeEntryType.VacationAdjustment:
                return "icon.time-entry.adjustment";
            case TimeEntryType.Free:
                return "icon.time-entry.free";
            case TimeEntryType.CompDay:
                return "icon.time-entry.comp-day";
            default:
                return "";
        }
    },
    mapOpenHoliday(holiday) {
        return {
            ..._getSchoolHolidayCoreData(holiday),
            states: holiday.nationwide
                ? GermanLocale.states.map((s) => s.code)
                : holiday.subdivisions?.map((s) => GermanLocale.openHolidayStateCodes[s.shortName]) || [],
        };
    },
};
const AustrianLocale = {
    states: [
        { name: "Burgenland", code: "AT-1" },
        { name: "Kärnten", code: "AT-2" },
        { name: "Niederösterreich", code: "AT-3" },
        { name: "Oberösterreich", code: "AT-4" },
        { name: "Salzburg", code: "AT-5" },
        { name: "Steiermark", code: "AT-6" },
        { name: "Tirol", code: "AT-7" },
        { name: "Vorarlberg", code: "AT-8" },
        { name: "Wien", code: "AT-9" },
    ],
    // OpenHolidays uses alternative state codes for Austria so we need to map them to the ISO state codes
    openHolidayStateCodes: {
        BL: "AT-1",
        KÄ: "AT-2",
        NÖ: "AT-3",
        OÖ: "AT-4",
        SB: "AT-5",
        SM: "AT-6",
        TI: "AT-7",
        VA: "AT-8",
        WI: "AT-9",
    },
    maxWorkingHoursPerDay: 12,
    minRestingHours: 11,
    maxProbationPeriodMonths: 3, // 1 Month for normal employees, 3 months for trainees
    timeEntryTypeLabel(timeEntry) {
        switch (timeEntry.type) {
            case TimeEntryType.ChildSick:
                return "Pflegeurlaub";
            default:
                return GermanLocale.timeEntryTypeLabel(timeEntry);
        }
    },
    timeEntryTypeIcon(type) {
        return GermanLocale.timeEntryTypeIcon(type);
    },
    mapOpenHoliday(holiday) {
        return {
            ..._getSchoolHolidayCoreData(holiday),
            states: holiday.nationwide
                ? AustrianLocale.states.map((s) => s.code)
                : holiday.subdivisions?.map((s) => AustrianLocale.openHolidayStateCodes[s.shortName]) || [],
        };
    },
};
function _getSchoolHolidayCoreData(holiday) {
    return {
        start: holiday.startDate,
        // OpenHolidays end days are inclusive, whereas in Pentacode end dates are exclusive
        end: dateAdd(holiday.endDate, { days: 1 }),
        name: holiday.name.find((n) => n.language === "DE")?.text || holiday.name[0].text || "Unbenannt",
    };
}
export const Localized = {
    DE: GermanLocale,
    AT: AustrianLocale,
};
//# sourceMappingURL=localized.js.map